<ng-container [formGroup]="parent">
  <ng-container formGroupName="shipTo">
    <h3 class="mb-2">Ship To</h3>
    <div class="row">
      <div>
        <div class="form-group has-float-label mb-2">
          <label class="form-label"
            >Delivery<span class="madatory-field">*</span></label
          >
          <p-select
            (onChange)="onDeliveryAddressChange($event.value)"
            formControlName="addressSelectionName"
            [(ngModel)]="defaultOneTime"
            [ngClass]="{ 'has-error': formErrors['addressSelectionName'] }"
            (onBlur)="logValidationErrorsEvent()"
            optionDisabled="status"
            [options]="deliveryAddress"
            optionLabel="name"
            optionValue="name">
          </p-select>

          <span class="error-msg" *ngIf="formErrors['addressSelectionName']">
            {{ formErrors["addressSelectionName"] }}
          </span>
        </div>
      </div>
      <div *ngIf="!fromAddressAssignment">
        <div class="form-group has-float-label mb-2">
          <label class="form-label"
            >Country/Region<span class="madatory-field">*</span></label
          >
          <p-select
            [(ngModel)]="countryRegionSelectedId"
            formControlName="countryRegionIdD365"
            (onChange)="onCountryRegionSelection(countryRegionSelectedId)"
            [ngClass]="{ 'has-error': formErrors['countryRegionIdD365'] }"
            (onBlur)="logValidationErrorsEvent()"
            [options]="countryRegionList"
            optionLabel="countryRegionD365"
            optionValue="countryRegionD365"
            [filter]="'true'">
          </p-select>

          <span class="error-msg" *ngIf="formErrors['countryRegionIdD365']">
            {{ formErrors["countryRegionIdD365"] }}
          </span>
        </div>
      </div>
    </div>

    <div class="ship-address" #shipaddress>
      <div
        class="form-group has-float-label mb-4"
        *ngIf="shipToAddress"
        id="dropdownBasic2">
        <label class="form-label">Client Ship To Name</label>
        <input
          pInputText
          jniAutoCompleteBlocker
          type="text"
          class="form-control"
          placeholder=""
          [value]="shiftToAddressField"
          (click)="onshipToAddressFilter($event, addressPopOver)"
          [disabled]="clientShipToAddressDisabled" />
      </div>
      <p-popover
        class="order-dropdown"
        #addressPopOver
        aria-labelledby="dropdownBasic2">
        <div class="indropdowntable">
          <p-table
            #dt
            [value]="shiftToAddressList"
            styleClass="p-datatable-customers order-listing"
            [rowHover]="true"
            [rows]="10"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            [paginator]="false"
            [filterDelay]="0">
            <ng-template pTemplate="header">
              <tr>
                <th class="name">Name and Description</th>
                <th class="name">Address</th>
                <th class="vaccount">Street</th>
                <th class="sname">Purpose</th>
              </tr>
            </ng-template>
            <ng-template
              pTemplate="body"
              let-shiftToAddressLists
              let-rowIndex="rowIndex">
              <tr
                class="p-selectable-row mousepointer"
                (click)="
                  onShitToAddressSeletion(shiftToAddressLists, addressPopOver)
                ">
                <td class="name mousepointer">
                  {{ shiftToAddressLists.descriptionD365 }}
                </td>
                <td class="name mousepointer">
                  {{ shiftToAddressLists.addressD365 }}
                </td>
                <td class="vaccount mousepointer">
                  {{ shiftToAddressLists.streetD365 }}
                </td>
                <td class="sname mousepointer">
                  {{ shiftToAddressLists.rolesD365 }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="20">No address found.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-popover>
    </div>

    <div class="v-account">
      <div
        class="form-group has-float-label mb-2"
        *ngIf="vendorAccountAndBook"
        id="dropdownBasic5">
        <label class="form-label">Vendor Account</label>
        <input
          #vendorAccountInputElt
          pInputText
          jniAutoCompleteBlocker
          type="text"
          class="form-control"
          placeholder=""
          formControlName="shipToVendorAccountD365"
          (input)="searchVendor$.next($any($event.target).value)"
          (keypress)="
            onVendorSearchOpenToggle(
              vendoraccountPopOver,
              $event,
              vendorAccountInputElt
            )
          " />
      </div>
      <p-popover
        class="order-dropdown max-width-600"
        #vendoraccountPopOver
        aria-labelledby="dropdownBasic5">
        <div class="indropdowntable" style="height: 200px">
          <p-table
            #dt
            [value]="vendorList"
            styleClass="p-datatable-customers order-listing"
            [rowHover]="true"
            [rows]="10"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            [paginator]="false"
            [filterDelay]="0"
            [scrollable]="true"
            scrollHeight="400px">
            <ng-template pTemplate="header">
              <tr>
                <th class="name">Name</th>
                <th class="vaccount">Vendor Account</th>
                <th class="sname">Search name</th>
                <th class="phone">Phone</th>
                <th class="city">City</th>
                <th class="state">State</th>
                <th class="country">Country</th>
              </tr>
            </ng-template>
            <ng-template
              pTemplate="body"
              let-vendorList
              let-rowIndex="rowIndex">
              <tr
                class="p-selectable-row mousepointer"
                (click)="
                  onVendorAccountSelection(
                    vendorList,
                    vendoraccountPopOver,
                    $event
                  )
                ">
                <td class="name mousepointer">
                  {{ vendorList.vendorName }}
                </td>
                <td class="vaccount mousepointer">
                  {{ vendorList.vendorAccountNumber }}
                </td>
                <td class="sname mousepointer">
                  {{ vendorList.vendorSearchName }}
                </td>
                <td class="phone mousepointer">
                  {{ vendorList.phoneNumber }}
                </td>
                <td class="city mousepointer">{{ vendorList.city }}</td>
                <td class="state mousepointer">{{ vendorList.state }}</td>
                <td class="country mousepointer">
                  {{ vendorList.country }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="20">No address found.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-popover>
    </div>
    <div #vendoraddressbook>
      <div
        class="form-group has-float-label mb-2"
        *ngIf="vendorAccountAndBook"
        id="dropdownBasic6">
        <label class="form-label">Vendor Ship To Name</label>
        <input
          jniAutoCompleteBlocker
          #vendorShipToNameInput
          pInputText
          type="text"
          class="form-control"
          placeholder=""
          [value]="addressBookName"
          (click)="
            onVendorAddressBookSelect(
              vendoraddressbookPopOver,
              vendorShipToNameInput,
              $event
            )
          "
          [disabled]="vendorNameShipToAddressDisabled" />
      </div>
      <p-popover
        class="order-dropdown"
        #vendoraddressbookPopOver
        aria-labelledby="dropdownBasic6">
        <p-table
          #dt
          [value]="addressBookList"
          styleClass="p-datatable-customers order-listing"
          [rowHover]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="false"
          [filterDelay]="0">
          <ng-template pTemplate="header">
            <tr>
              <th class="name">Name or description</th>
              <th class="vaccount">Address</th>
              <th class="sname">Primary</th>
              <th class="sname">Purpose</th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-addressBookLists
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row mousepointer"
              (click)="
                onVendorAddressBookSelection(
                  addressBookLists,
                  vendoraddressbookPopOver
                )
              ">
              <td class="vaccount mousepointer">
                {{ addressBookLists.descriptionD365 }}
              </td>
              <td class="vaccount mousepointer">
                {{ addressBookLists.addressD365 }}
              </td>
              <td class="vaccount mousepointer">
                {{ addressBookLists.isPrimaryD365 }}
              </td>
              <td class="sname mousepointer">
                {{ addressBookLists.rolesD365 }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No address found.</td>
            </tr>
          </ng-template>
        </p-table>
      </p-popover>
    </div>

    <div
      class="form-group has-float-label mb-2 address-lookup"
      [hidden]="showAddress">
      <label class="form-label">Address Lookup</label>

      <p-autocomplete
        jniAutoCompleteBlocker
        id="addressFormat"
        name="addressFormat"
        formControlName="addressFormat"
        [ngModel]="melissa"
        (onSelect)="selectedStreet($event)"
        (completeMethod)="searchMelissaAutoComplete($event)"
        (onChange)="enableAndDisabledValidateButton()"
        [suggestions]="usSuggestions"
        [forceSelection]="false"
        [optionLabel]="'Address.Address'"
        [dropdown]="false">
        <ng-template let-address #item>
          {{ melissaFormatter(address) }}
        </ng-template>
      </p-autocomplete>
    </div>
    <div [hidden]="appartmentFieldStatus">
      <div
        class="form-group has-float-label mb-4"
        *ngIf="appartmentList.length">
        <label class="form-label">Suite Selection Box</label>
        <p-select
          [(ngModel)]="selectedAppartment"
          pInputText
          formControlName="buildingComplimentD365"
          (onChange)="onAppartmentSelection($event)"
          [ngClass]="{ 'has-error': !appartmentFieldStatus }"
          #selector
          [options]="appartmentList">
        </p-select>
      </div>
    </div>

    <div
      class="form-group has-float-label mb-4"
      [hidden]="
        nonUsandCadFieldStatus || showAddressLinesFields || collapseStatus
      ">
      <label class="form-label"
        >Address Line 1 <span class="madatory-field">*</span></label
      >
      <p-autoComplete
        jniAutoCompleteBlocker
        class="form-control"
        id="addressFormat"
        name="addressFormat"
        placeholder=""
        [suggestions]="nonUSSuggestions"
        [optionLabel]="'Address.Address'"
        [dropdown]="false"
        formControlName="addressFormat"
        [ngModel]="melissaForNonUsAddress1"
        (completeMethod)="getMelissaGlobalData($event.query)"
        (onSelect)="selectedStreetForNonUs($event)"
        (onChange)="enableAndDisabledValidateButton()">
        <ng-template let-item pTemplate="item">
          {{ item.Address?.Address }}
        </ng-template>
      </p-autoComplete>
    </div>
    <div
      class="form-group has-float-label mb-4"
      [hidden]="
        nonUsandCadFieldStatus || showAddressLinesFields || collapseStatus
      ">
      <label class="form-label">Address Line 2</label>
      <input
        jniAutoCompleteBlocker
        type="text"
        pInputText
        class="form-control"
        id="addressFormat"
        name="addressFormat"
        placeholder=""
        formControlName="addressLine2"
        [(ngModel)]="address2" />
    </div>
    <div
      class="form-group has-float-label mb-4"
      [hidden]="
        nonUsandCadFieldStatus || showAddressLinesFields || collapseStatus
      ">
      <label class="form-label">Address Line 3</label>
      <input
        jniAutoCompleteBlocker
        type="text"
        pInputText
        class="form-control"
        id="addressFormat"
        name="addressFormat"
        placeholder=""
        formControlName="addressLine3"
        [(ngModel)]="address3" />
    </div>
    <div
      class="form-group has-float-label mb-4"
      [hidden]="nonUsandCadFieldStatus || collapseStatus">
      <label class="form-label"
        >City/Locality <span class="madatory-field">*</span></label
      >
      <input
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="cityD365"
        pInputText
        name="cityD365"
        placeholder=""
        formControlName="cityD365"
        [(ngModel)]="city"
        (change)="enableAndDisabledValidateButton()" />
    </div>
    <div
      class="form-group has-float-label mb-4"
      [hidden]="nonUsandCadFieldStatus || collapseStatus">
      <label class="form-label"
        >State/Province <span class="madatory-field">*</span></label
      >
      <input
        jniAutoCompleteBlocker
        type="text"
        pInputText
        class="form-control"
        id="stateD365"
        name="stateD365"
        placeholder=""
        formControlName="stateD365"
        [(ngModel)]="state"
        (change)="enableAndDisabledValidateButton()" />
    </div>
    <div
      class="form-group has-float-label mb-4"
      [hidden]="nonUsandCadFieldStatus || collapseStatus">
      <label class="form-label"
        >Postal Code <span class="madatory-field">*</span></label
      >
      <input
        jniAutoCompleteBlocker
        type="text"
        pInputText
        class="form-control"
        id="zipCodeD365"
        name="zipCodeD365"
        placeholder=""
        formControlName="zipCodeD365"
        [(ngModel)]="postalcode"
        (change)="enableAndDisabledValidateButton()" />
    </div>
    <div
      class="form-group has-float-label mb-4"
      [hidden]="nonUsandCadFieldStatus || collapseStatus">
      <label class="form-label"
        >Street <span class="madatory-field">*</span></label
      >
      <input
        jniAutoCompleteBlocker
        type="text"
        pInputText
        class="form-control"
        id="streetD365"
        name="streetD365"
        placeholder=""
        formControlName="streetD365" />
    </div>
    <div class="form-group has-float-label mb-2" *ngIf="showName">
      <label class="form-label">Name</label>
      <input
        jniAutoCompleteBlocker
        pInputText
        type="text"
        class="form-control"
        formControlName="deliveryNameD365"
        [ngClass]="{ 'has-error': formErrors['deliveryNameD365'] }"
        (blur)="logValidationErrorsEvent()" />

      <span class="error-msg" *ngIf="formErrors['deliveryNameD365']">
        {{ formErrors["deliveryNameD365"] }}
      </span>
    </div>
    <div
      class="form-group has-float-label mb-2"
      *ngIf="!fromAddressAssignment"
      [hidden]="collapseStatus">
      <label class="form-label">Attention</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        placeholder=""
        formControlName="attentionInformationD365"
        maxlength="30" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      *ngIf="!fromAddressAssignment"
      [hidden]="collapseStatus">
      <label class="form-label">Location</label>
      <input
        jniAutoCompleteBlocker
        pInputText
        type="text"
        class="form-control"
        placeholder=""
        formControlName="locationD365"
        maxlength="30" />
    </div>
    <!-- <jni-address
      *ngIf="showAddressComponent()"
      [parent]="parent"
      [cityList]="cityList"
      [countryRegionList]="countryRegionList"
      [countyList]="countyList"
      [districtList]="districtList"
      [formgroupName]="'shipTo'"
      [hiddenHeadingStatus]="true"
    >
    </jni-address> -->

    <div class="form-group has-float-label" [hidden]="collapseStatus">
      <label class="form-label" for="c_name">Address</label>
      <textarea
        jniAutoCompleteBlocker
        pInputText
        formControlName="addressD365"
        class="form-control"
        style="height: 100px"
        (change)="formattedAddressChange()"
        [ngClass]="{ 'has-error': isAddressError }"></textarea>

      <span class="error-msg" style="position: static" *ngIf="isAddressError">
        {{ melissaErrorMessage }}
        <!-- Address is not valid -->
      </span>
    </div>
    <div
      class="form-group has-float-label mb-2"
      [hidden]="isPrimaryFieldStatus || collapseStatus">
      <div class="switcher">
        <div class="form-label mb-1">Primary:</div>
        <div class="d-flex align-items-center form-switch">
          <label class="form-check-label" for="rcCheck">{{
            this.parent.get(["addressInformation", "isPrimaryD365"])?.value
          }}</label>
          <input
            pInputText
            name="rcCheck"
            class="form-check-input me-2"
            [checked]="false"
            type="checkbox"
            id="rcCheck"
            formControlName="isPrimaryD365" />
        </div>
      </div>
    </div>
    <div class="form-group has-float-label mb-2" [hidden]="true">
      <label class="form-label" for="c_name">validateAddress</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        formControlName="validateAddress"
        class="form-control"
        style="height: 120px" />
    </div>
    <div
      class="col mb-2 d-flex align-items-center justify-content-end"
      [hidden]="collapseStatus">
      <div class="form-group has-float-label">
        <!-- <button
          type="button"
          style="margin-left: 10px"
          (click)="saveAddressForNonUs(true)"
          [hidden]="hideNonUsAddressSaveButton"
          class="btn validate btn-primary"
        >
          save
        </button> -->

        <button
          type="button"
          style="margin-left: 10px"
          (click)="validateAddress(true)"
          [hidden]="hideValidateButton"
          class="btn validate"
          [ngClass]="{
            'btn-success': addressValidationStatus === false,
            'btn-primary': addressValidationStatus === true,
            'btn-danger': isAddressError === true,
          }">
          Validate address
        </button>
      </div>
    </div>
    <div
      class="form-group has-float-label"
      *ngIf="!fromAddressAssignment"
      [hidden]="collapseStatus">
      <label class="form-label">Ship to email</label>
      <input
        jniAutoCompleteBlocker
        type="email"
        pInputText
        class="form-control"
        placeholder=""
        formControlName="rSMJNIShipToEmailD365"
        [disabled]="isEditFromCdi" />
    </div>

    <p-dialog
      [(visible)]="modalOpen"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [showHeader]="false">
      <div class="cp-ord-sum-dialogue">
        <div class="dialog-content">
          <h3>
            Your address was not validated and may not get to the recipient. Do
            you want to continue?
          </h3>
        </div>
        <div class="btns d-flex justify-content-center">
          <button
            class="btn btn-success"
            (click)="onConfirmContinueWithoutValidation()">
            Yes
          </button>
          <button
            class="btn btn-danger"
            (click)="onCancelContinueWithoutValidation()"
            style="margin-left: 0.8rem">
            No
          </button>
        </div>
      </div>
      <ng-template pTemplate="footer"></ng-template>
    </p-dialog>
    <br class="br" />
    <button
      *ngIf="
        (!isAddressValidatedByMelissa || showContinueWithoutValidation) &&
        isShipToAddressFromOrder
      "
      (click)="continueWithoutValidation()"
      class="btn btn-warning"
      [hidden]="collapseStatus">
      Continue Without Validation
    </button>
  </ng-container>
</ng-container>
